<template>
    <div>
        <v-navigation-drawer
            v-model="fileUploadDialog"
            app
            relative
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card tile class="drawer-content pb-12">
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                        Upload Project Deliverables
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            @click="closeUploadDeliverables">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="pt-3">
                    <UploadDeliverables 
                        :projectData="projectDeliverables"
                        :moduleKey="projectDeliverables.modinfo.module_key"
                        :projectId="projectDeliverables.project_id"
                        :userId="projectDeliverables.user_id"
                        :isDeliverable="true"
                        :revisionDocCount="3"
                        @triggerUserFeedback="triggerUserFeedback"
                        @closeUploadDeliverables="closeUploadDeliverables"
                        @refreshDocs="refreshDocs"
                    />
                </v-card-text>
            </v-card>
        </v-navigation-drawer>

        <div class="my-6 mb-12">
            <div class="d-flex d-block align-center mb-2">
                <div class="sansation label_medium info--text d-inline">Project Deliverables</div>
                <div class="d-inline ml-7 info--text">{{ projectDeliverables.dlvs.length }} file{{ projectDeliverables.dlvs.length == 1 ? '':'s' }}</div>
                <div class="d-inline ml-7 info--text" v-if="projectDeliverables.modinfo.module_key.includes('entity-maintenance-program')">
                    <a
                        class="d-inline menu_bg_primary primary--text text--darken-1"
                        :href="`${appUrls.pdf}/generate?download=true&url=${appUrls.api}/generated/emp/data-sheet/${projectDeliverables.project_id}`"
                        target="_blank"
                    >
                        Generate Data Sheet
                    </a>
                </div><div class="d-inline ml-7 info--text" v-if="projectDeliverables.modinfo.module_key.includes('entity-maintenance-program')">
                    <a
                        class="d-inline menu_bg_primary primary--text text--darken-1"
                        :href="`${appUrls.pdf}/generate?download=true&name=${annual_report_year}_Annual Filing Confirmation&url=${appUrls.api}/generated/emp/annual-filing/${projectDeliverables.project_id}`"
                        target="_blank"
                    >
                        Generate Annual Filing
                    </a>
                </div>
                <v-spacer></v-spacer>
                <div class="d-inline">
                    <v-btn
                        small
                        class="ml-6  d-inline menu_bg_primary primary--text text--darken-1"
                        elevation=0
                        @click="fileUploadDialog = true">
                        Upload Deliverables
                        <v-icon small color="primary" class="ml-2" right>mdi-cloud-upload</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-data-table
                v-if="projectDeliverables.dlvs.length"
                :headers="dlv_headers"
                :items="projectDeliverables.dlvs"
                :options.sync="options"
                :loading="refresh_delivs"
                disable-pagination
                hide-default-footer>
                
                <template v-slot:header="{ headers }">
                    <thead>
                        <tr>
                            <td v-for="column in headers" :key="column.value">
                                {{column.text}}
                            </td>
                        </tr>
                    </thead>
                </template>

                <template v-slot:body="{ items }">
                    <tbody name="list" is="transition-group">
                        <tr v-for="item in items" :key="item.key" class="item-row">
                            <td class="text-start"><a :href="item.url" target="_blank">{{ item.file_name }}</a></td>
                            <td class="text-start">{{ item.deliverable_type }}</td>
                            <td class="text-start">{{ formatDate(item.received) }}</td>
                            <td class="text-start">{{ item.user_name }}</td>
                            <td class="text-start">{{ formatDate(item.file_upload_date) }}</td>
                            <td class="text-end" width="2%">
                                <v-icon
                                    small
                                    @click="deleteFile(item)">
                                    mdi-delete
                                </v-icon>
                            </td>
                        </tr>
                    </tbody>
                </template>

            </v-data-table>
        </div>
    </div>
</template>


<script>  
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';

    import UploadDeliverables from './UploadDeliverables'
    // import UserData_Dashboard from './UserData_Dashboard'

    export default {
        name: 'ProjectDeliverables',

        components: {
            UploadDeliverables,
            // UserData_Dashboard
        },

        props: {
            projectDeliverables: Object,
            refresh_delivs: Boolean,
            triggerUserFeedback: Function,
            formatThisDate: Function,
            pullProjectDelivs: Function
        },

        computed: {
            appUrls() {
                return appUrls;
            },
            annual_report_year() {
                let rYear = (new Date()).getFullYear();
                if (this.projectDeliverables.annual_report_filing_date != "") {
                    rYear = this.projectDeliverables.annual_report_filing_date.split('-')[0];
                }
                return rYear;
            }
        },

        data () {
            return {
                fileUploadDialog: false,
                dlv_headers: [
                    {   text: 'File Name',
                        value: 'file_name',
                        align: 'start',
                        sortable: true 
                    },
                    {   text: 'Document Type',
                        value: 'deliverable_type',
                        align: 'left',
                        sortable: true
                    },
                    {   text: 'Download Date',
                        value: 'received',
                        align: 'left',
                        sortable: true 
                    },
                    {   text: 'Uploaded By',     
                        value: 'user_name',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: 'Uploaded',
                        value: 'file_upload_date',
                        align: 'left',
                        sortable: true
                    },
                    {   text: ' ',
                        value: '',
                        align: 'right',
                        sortable: false
                    }
                ],
                options: {
                    sortBy: ['file_upload_date'],
                    sortDesc: [true],
                    // Initialize other options as needed
                    itemsPerPage: -1,
                    multiSort: true
                },
            }
        },
       
        methods: {
            formatDate: function ( date_to_format ) {
                const options = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }

                const formatted_date = this.formatThisDate(date_to_format, options);
                return formatted_date ? formatted_date : 'N/A';
            },

            closeUploadDeliverables: function () {
                this.fileUploadDialog = false 
            },

            refreshDocs: function () {
                this.$emit('pullProjectDelivs', this.projectDeliverables )
            },
            
            deleteFile: async function (item) {
                try {
                    // console.log(item)
                    const confirm_rs = confirm('Are you sure you want to delete this file from this project?');

                    if ( confirm_rs ) { 
                        const delete_deliverable_file = await axios.put(`${appUrls.api}/api/rm_uploaded_file`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            file_data: item
                        });

                        if ( delete_deliverable_file.data.outcome ) {
                            this.$emit('pullProjectDelivs', this.projectDeliverables)
                        } else {
                            // this.$emit('pullProjectDelivs', this.projectDeliverables)
                        }
                    }
                } catch ( err ) {
                    console.log( err )
                }
            },
        },

        mounted () {
            // console.log(this.projectDeliverables)
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bg_pewter {
        background-color: #E9EAEC;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 2.5rem;
    }
    .icon-center {
        margin: 0 auto;
    }
    .drawer-shadow {
        z-index: 2000;
        box-shadow: -6px 0 12px rgba(0, 0, 0, 0.15);
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
        background-color: whitesmoke !important;
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectDeliverables.vue